import * as React from "react";
import { useState } from "react";
import { SliderSetBox } from "../Components/SliderSetBox";
import { BannerSetBox } from "../Components/BannerSetBox";
import { PanelContainer } from "../Components/PanelContainer";
import { ShopSliderSetBox } from "../Components/ShopSliderSetBox";
import { DescriptionSetBox } from "../Components/DescriptionSetBox";
export const Banners = () => {
  const [activeComponent, setActiveComponent] = useState(null);
  const handleSetDescription = ()=>{
    setActiveComponent('description')
  }
  const handleSetShopSlider = ()=>{
    setActiveComponent('shop')
  }
  const handleSetSlider = () => {
    setActiveComponent("slider");
  };
  const handleSetFirstBanner = () => {
    setActiveComponent("firstBanner");
  };
  const handleSetSecondBanner = () => {
    setActiveComponent("secondBanner");
  };
  return (
    <>
      <PanelContainer
        title={"لطفاً ناحیه قرار گیری بنر مورد نظر را انتخاب کنید"}
        className={"d-flex  align-items-center justify-content-center"}
      >
        <div className="w-75">
          <div id="ContentPlaceHolder1_PanelUpBanner">
            <hr />
            <div className="alert alert-secondary w-100 text-center">
              اسلاید ها و بنرهای اصلی
            </div>
            <div className="row mb-4">
              <div className="col-8 m-auto pr-0">
                <div
                  onClick={handleSetSlider}
                  id="ContentPlaceHolder1_BtnMainBanner"
                  className="btn btn-primary prime-bg2 w-100 p-4"
                >
                  اسلایدر صفحه اصلی
                </div>
              </div>
              <div className="col-4 m-auto p-0">
                <div
                  onClick={handleSetFirstBanner}
                  id="ContentPlaceHolder1_Btnup3"
                  className="btn btn-primary prime-bg2 w-100 mb-1"
                >
                  بنر چپ بالا
                </div>
                <br />
                <div
                  onClick={handleSetSecondBanner}
                  id="ContentPlaceHolder1_Btnup4"
                  className="btn btn-primary prime-bg2 w-100"
                >
                  بنر چپ پایین
                </div>
              </div>
            </div>
            <div className="alert alert-secondary w-100 text-center">
              بنر فروشگاه
            </div>
            <div className="row mb-4">
              <div className="col-8 m-auto pr-0">
                <div
                  onClick={handleSetShopSlider}
                  id="ContentPlaceHolder1_BtnMainBanner"
                  className="btn btn-primary prime-bg2 w-100 p-4"
                >
                  بنر اسلایدر
                </div>
              </div>
            </div>
            <div className="alert alert-secondary w-100 text-center">
              اسلاید ها و بنرها
            </div>
          </div>
          <div className="row">
            <div className="col-8 m-auto pr-0">
              <div
                onClick={handleSetDescription}
                id="ContentPlaceHolder1_BtnMainBanner"
                className="btn btn-primary prime-bg2 w-100 p-4"
              >
                متن صفحه اصلی
              </div>
            </div>
          </div>
        </div>
      </PanelContainer>
      {activeComponent === "slider" && <SliderSetBox />}
      {activeComponent === "shop" && <ShopSliderSetBox />}
      {activeComponent === "firstBanner" && <BannerSetBox position={1} />}
      {activeComponent === "secondBanner" && <BannerSetBox position={2} />}
      {activeComponent === "description" && <DescriptionSetBox />}
    </>
  );
};
